module.exports = __webpack_public_path__ + "0ac6a4d53ec8a56fb989df4c618c3926.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-black.ttf
 ** module id = 21
 ** module chunks = 0
 **/